var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsdt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#26A17B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4415 13.0373V13.0358C13.359 13.0418 12.9338 13.0673 11.985 13.0673C11.2275 13.0673 10.6943 13.0448 10.5068 13.0358V13.038C7.59076 12.9098 5.41426 12.402 5.41426 11.7945C5.41426 11.1878 7.59076 10.68 10.5068 10.5495V12.5325C10.6973 12.546 11.2433 12.5783 11.9978 12.5783C12.903 12.5783 13.3568 12.5408 13.4415 12.5333V10.551C16.3515 10.6808 18.5228 11.1885 18.5228 11.7945C18.5228 12.402 16.3515 12.9083 13.4415 13.0373ZM13.4415 10.3448V8.57026H17.502V5.86426H6.44626V8.57026H10.5068V10.344C7.20676 10.4955 4.72501 11.1495 4.72501 11.9325C4.72501 12.7155 7.20676 13.3688 10.5068 13.521V19.2075H13.4415V13.5195C16.7363 13.368 19.212 12.7148 19.212 11.9325C19.212 11.1503 16.7363 10.497 13.4415 10.3448Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.2499bf8784f2ab7c736c5e1b8a350095.svg";
export { ForwardRef as ReactComponent };